import { render, staticRenderFns } from "./signContract.vue?vue&type=template&id=2cc47d1d&"
import script from "./signContract.vue?vue&type=script&lang=js&"
export * from "./signContract.vue?vue&type=script&lang=js&"
import style0 from "./signContract.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports